import { render, staticRenderFns } from "./ComprobanteCliente.vue?vue&type=template&id=7343a1da"
import script from "./ComprobanteCliente.vue?vue&type=script&lang=js"
export * from "./ComprobanteCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports